export default __webpack_public_path__ + "static/media/no-transactions.adf8ae89.png";